import React from "react";
import { Plan, PlanDetailsSection } from "../../../@types";
import {
  PlanDetailSection,
  DrugPlanStarRatings,
  PlanOverallStarRating,
} from "../../../components";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useTranslate, hideStarRatings } from "../../../helpers";

const StarRatings: React.FunctionComponent<{ plan: Plan }> = ({ plan }) => {
  const { feEnableStarRatings, mctCurrentPlanYear } = useFlags();
  const t = useTranslate();

  return (
    <PlanDetailSection
      id={PlanDetailsSection.STAR_RATINGS}
      title={t("plan_stars.medicare.star_ratings")}
    >
      <PlanOverallStarRating
        highPerforming={plan.high_performing}
        lowPerforming={plan.low_performing}
        starRating={plan.overall_star_rating}
        planYear={plan.contract_year}
      />
      {!hideStarRatings(plan.contract_year, {
        feEnableStarRatings,
        mctCurrentPlanYear,
      }) && <DrugPlanStarRatings plan={plan} />}
    </PlanDetailSection>
  );
};

export default StarRatings;
